jQuery(document).ready(function () {
  const videos = document.querySelectorAll(".custom-video");
  // Get all circle play buttons
  const playButtons = document.querySelectorAll(".cstm-requirment");
  // Add click event listener to each play button
  playButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      const video = videos[index];
      if (video.paused) {
        video.play();
        button.style.opacity = 0;
      } else {
        video.pause();
        button.style.opacity = 1;
      }
    });
  });

  $(".open-popup").on("click", function () {
    $("body").addClass("modal-open-cstm");
    $("#overlay").fadeIn();
    var id = $(this).data("id");
    $('.js-modal[data-id="modal' + id + '"]').fadeIn();
  });

  $(".js-close-btn").on("click", function () {
    $("body").removeClass("modal-open-cstm");
    $("#overlay").fadeOut();
    $(".js-modal").fadeOut();
  });
  $("#overlay").on("click", function () {
    $("body").removeClass("modal-open-cstm");
    $("#overlay").fadeOut();
    $(".js-modal").fadeOut();
  });

  $(".review-popup").on("click", function () {
    $("body").addClass("modal-open-cstm");
    $("#overlay").fadeIn();
    var id = $(this).data("id");
    $('.review-modal[data-id="modal' + id + '"]').fadeIn();
  });

  $(".rev-close-btn").on("click", function () {
    $("body").removeClass("modal-open-cstm");
    $("#overlay").fadeOut();
    $(".review-modal").fadeOut();
  });
  $("#overlay").on("click", function () {
    $("body").removeClass("modal-open-cstm");
    $("#overlay").fadeOut();
    $(".review-modal").fadeOut();
  });
});
